<template>
  <div id="uparrow">
    <b-img :src="image" fluid alt="Up Arrow" @click="scrollToTop"></b-img>
  </div>
</template>

<script>
// import { VueElevator } from 'vue-elevator'

// Vue.component('VueElevator', VueElevator)

export default {
  data() {
    return {
      image: require('@/assets/image/common/uparrow.png')
    }
  }, 
  methods: {
    scrollToTop(to) {
      if (to.hash) {
        const element = document.getElementById(to.hash.slice(1));
        if (element) {
          return window.scrollTo({
            top: element.offsetTop,
            behavior: 'smooth'
          });
        }
      }
      return window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
}
</script>

<style>
    #uparrow img{
        /* text-align: center; */
        padding: 30px 0 40px 0;
        margin-left: auto;
        margin-right: auto;
        display: block;
        cursor: pointer;
    }
</style>